const PREFIX = 'ACCOUNT_INFO_';

export const SET_LOADING = `${PREFIX}SET_LOADING`;
export const UNSET_LOADING = `${PREFIX}UNSET_LOADING`;
export const SET_IS_BANKING_REQUIRED = `${PREFIX}SET_IS_BANKING_REQUIRED`;
export const SET_IS_REIMBURSEMENT_ENABLED = `${PREFIX}SET_IS_REIMBURSEMENT_ENABLED`;
